/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
// MessagesContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const MessagesContext = createContext();

export const MessagesProvider = ({ isDesktop, children }) => {
  const [messages, setMessages] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        let loadedMessages;
        if (isDesktop) {
          loadedMessages = await import('../assets/translate/messages.desktop.js');
        } else {
          loadedMessages = await import('../assets/translate/messages.nube.js');
        }
        setMessages(loadedMessages.MESSAGES);
        setLoading(false);
      } catch (err) {
        setError(err);
      }
    };

    fetchMessages();
  }, [isDesktop]);

  return (
    <MessagesContext.Provider value={{ messages, loading }}>
      {children}
    </MessagesContext.Provider>
  );
};

export const useMessages = () => useContext(MessagesContext);
